import { HStack, Pressable } from 'native-base';

import { Text } from '@pimm/base';

export interface ChipDef {
  id: string;
  label: string;
  count: number;
}

type EquipmentFilterChipsProps = {
  chips: ChipDef[];
  value: string;
  onChange: (id: string) => void;
};

export const EquipmentFilterChips = ({ chips, value, onChange }: EquipmentFilterChipsProps) => {
  const changeFilter = (id: string) => () => onChange(id);

  return (
    <HStack space={2} flexWrap="wrap" alignItems="center">
      {chips.map(chip => {
        const isActive = chip.id === value;
        const color = isActive ? 'primary' : 'gray';
        return (
          <Pressable
            key={chip.id}
            onPress={changeFilter(chip.id)}
            px={3}
            h={9}
            rounded="lg"
            shadow={1}
            bg={isActive ? `${color}.50` : 'white'}
            borderWidth={1}
            borderColor={`${color}.${isActive ? 600 : 300}`}
            justifyContent="center"
            _pressed={{ opacity: 0.8 }}
          >
            <HStack space={1} alignItems="center">
              <Text size="sm" fontWeight={600} color={`${color}.600`}>
                {chip.label}
              </Text>
              <Text size="sm" fontWeight={600} color={`${color}.500`}>
                {chip.count}
              </Text>
            </HStack>
          </Pressable>
        );
      })}
    </HStack>
  );
};
